import React from 'react';
import { Tag, Tooltip } from 'antd';
import { RobotOutlined, WarningOutlined } from '@ant-design/icons';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

const AiBotDetectedBadge = ({ customer, onUnmark }) => {
  if (!customer.aiBotDetected) {
    return null;
  }

  const detectedAt = customer.aiBotDetectedAt 
    ? format(new Date(customer.aiBotDetectedAt), "dd/MM/yyyy 'às' HH:mm", { locale: ptBR })
    : 'Data desconhecida';

  const tooltipContent = (
    <div>
      <div><strong>🤖 Bot de IA Detectado</strong></div>
      <div style={{ marginTop: 8 }}>
        <strong>Detectado em:</strong> {detectedAt}
      </div>
      {customer.aiBotDetectionReason && (
        <div style={{ marginTop: 4 }}>
          <strong>Motivo:</strong> {customer.aiBotDetectionReason}
        </div>
      )}
      <div style={{ marginTop: 8, fontSize: '11px', opacity: 0.8 }}>
        Este cliente foi identificado como um sistema automatizado e está bloqueado para evitar loops infinitos.
      </div>
      {onUnmark && (
        <div style={{ marginTop: 8, fontSize: '11px', fontStyle: 'italic' }}>
          Clique no badge para desbloquear se for um falso positivo.
        </div>
      )}
    </div>
  );

  return (
    <Tooltip title={tooltipContent} placement="top">
      <Tag 
        icon={<RobotOutlined />} 
        color="error"
        style={{ 
          cursor: onUnmark ? 'pointer' : 'default',
          fontWeight: 500
        }}
        onClick={onUnmark ? () => onUnmark(customer) : undefined}
      >
        Bot IA Detectado
      </Tag>
    </Tooltip>
  );
};

export default AiBotDetectedBadge;
